import React from "react";
import { useField } from "formik";
import { makeStyles } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Text, { types } from "../Text/Text";
import colors from "../../config/colors";

const useStyles = makeStyles(theme => ({
  field: {
    margin: `${theme.spacing(1)}px 0`,
    width: "100%"
  },
  formControl: {
    width: "100%",
    backgroundColor: "white",
    borderRadius: 12,
    boxShadow: "0px 0px 20px 4px rgb(0 0 0 / 5%)"
  },
  select: {
    borderRadius: 12
  },
  labelContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: theme.spacing(0.5)
  },
  error: {
    border: `1px solid ${colors.error}`
  },
  placeholder: {
    color: "#A2A7B1"
  },
  errorText: {
    marginLeft: 8
  },
  menuPaper: {
    borderRadius: 12
  }
}));

const SelectInput = ({
  className,
  label,
  name,
  options = [],
  placeholder = "-- Select an option --",
  ...rest
}) => {
  const [field, meta] = useField(name);
  const classes = useStyles();
  const showError = meta.touched && meta.error;
  const isPlaceholder = field.value === "";

  return (
    <div className={`${classes.field} ${className}`} id={name}>
      <div className={classes.labelContainer}>
        <Text type={types.inputLabel}>
          {label}
          {showError && " ·"}
        </Text>
        {showError && (
          <Text type={types.fieldError} className={classes.errorText}>
            {meta.error}
          </Text>
        )}
      </div>

      <FormControl
        variant="outlined"
        className={classes.formControl}
        error={showError}
      >
        <Select
          {...field}
          displayEmpty
          className={`${classes.select} ${isPlaceholder && classes.placeholder}`}
          MenuProps={{
            PaperProps: {
              className: classes.menuPaper
            }
          }}
          {...rest}
        >
          <MenuItem value="" disabled>
            {placeholder}
          </MenuItem>
          {options.map(opt => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default SelectInput;
